module.exports = (__parcel__import__("23ip3")).then(() => parcelRequire('4MKVl'));